import { transition, trigger } from '@angular/animations';
import { Component, OnInit, HostBinding, OnDestroy } from '@angular/core';
import { SlideInOutAnimation } from './../../app.animations';
import { AccountService } from '../../../app/services/account.service';
import { IdleLogoutService } from '../../../app/services/idle-logout.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  animations: [trigger('routeAnimation', [transition('* => *', SlideInOutAnimation)])],
})
export class AdminComponent implements OnInit, OnDestroy {
  @HostBinding('class.portal') true;
  toggle: any;
  constructor(private accountService: AccountService, private idleLogoutService: IdleLogoutService) {
    this.accountService.emitChange.subscribe((status) => (this.toggle = status));
  }
  ngOnInit() {
    // Initialize idle logout for admin module
    this.idleLogoutService.initializeIdleLogout('admin');
  }

  toggleMenu(e) {
    this.toggle = e;
  }

  ngOnDestroy() {
    // Disable idle logout when component is destroyed
    this.idleLogoutService.disableIdleLogout();
  }
}
